import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import AppProvider from '@/app/providers'

import './index.css'

// Sentry 11 captures Sentry.logger calls without an enableLogs option.
Sentry.init({
	dsn: 'https://9667497ca16217a880cdbfffaf3118c9@sentry.eltc.ru/76', // Replace with the full DSN for your Sentry project.
	dataCollection: {
		userInfo: true
	},
	integrations: [Sentry.replayIntegration()],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0
})

createRoot(document.getElementById('root')!).render(<AppProvider />)
